import { Textarea } from "@dcloudio/uni-h5";

let callbacks	= [];
let dialogs		= [];
let time		= 0;

let hotkey = {
	init : ()=>{
		document.addEventListener('keydown', keyDown);
		document.addEventListener('keyup', keyUp);
		document.addEventListener('dblclick', dblClick);
	},
	
	on: (event, callback, replace)=>{
		event = event.toLowerCase();
		if(!callbacks[event]) replace = true;
		
		if(replace) {
			callbacks[event] = [callback];
		} else {
			callbacks[event].push(callback);
		}
	},
	
	remove: (event, callback)=>{
		event = event.toLowerCase();
		if(!callbacks[event]) return;
		
		for(let key in callbacks[event]) {
			if(callbacks[event][key] == callback){
				callbacks[event].splice(key, 1);
				return true;
			}
		}
		
		return false;
	},
	
	command : false,
}

function call(event, e, pop){
	e.stopPropagation();
	e.preventDefault();
	
	if(!callbacks[event]) return;
	
	let t = new Date().getTime();
	
	if(t - time < 200) {
		//dyEditor.toast.error('你按得太快了，休息一下吧');
		return;
	}
	
	time = t;
	
	for(let key in callbacks[event]){
		if(pop) {
			callbacks[event].pop()(e);
			break;
		} else {
			callbacks[event][key](e);
		}
	}
}

//按键
function keyDown(e){
	//console.log(e.keyCode);
	//mac command
	if(!dyConfig.data.init) return;
	
	if(dyEditor.isMac() && e.keyCode == 91){
		hotkey.command = true;
	}
	
	//ESC
	if(e.keyCode == 27
	&& e.target.nodeName!='INPUT'
	&& e.target.nodeName!='TEXTAREA'
	&& e.target.nodeName!='P'
	&& e.target.getAttribute('contenteditable') != 'true'){
		return call('esc', e, true);
	}
	
	//enter
	if(e.keyCode == 13 
	&& e.target.nodeName!='INPUT' 
	&& e.target.nodeName!='TEXTAREA'
	&& e.target.nodeName!='P'
	&& e.target.getAttribute('contenteditable') != 'true'){
		// e.stopPropagation();
		// e.preventDefault();
		return call('enter', e, true);
	}
		
	//按住CTRL键
	if(e.ctrlKey || hotkey.command) {
		if( e.ctrlKey && dyEditor.isMac()) return;
		
		switch(e.keyCode){
			case 13:		//publish
				return call('publish', e);
				
			case 49:		//移动节点
				return call('move', e);
				
			case 50:		//视角关键帧
				return call('view', e);
				
			case 83:		//save
				dyEditor.save();
				return call('save', e);
		}
		
	//按住ALT键
	} else if(e.altKey){
		switch(e.keyCode){
			case 13:		//preview
				return call('preview', e);
			
			case 49:		//全局
				return call('base', e);
				
			case 50:		//开场
				return call('splash', e);
				
			case 51:		//视角
				return call('fov', e);
				
			case 52:		//热点
				return call('hotspot', e);
			
			case 53:		//平面
				return call('plan', e);
				
			case 54:		//音乐
				return call('music', e);
				
				
			case 112:		//全景管理
				return call('panomanage', e);
				
			case 113:		//全景编辑
				return call('panoeditor', e);
		}
	}
}

function keyUp(e){
	//mac command
	if(dyEditor.isMac() && e.keyCode == 91){
		hotkey.command = false;
	}
}

//鼠标双击
function dblClick(e){
	if(e.ctrlKey){
		
	}
}

export default hotkey;